import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, authed, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      authed
        ? <Component {...props} />
        : <Redirect to="/sign" />
    )}
  />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/containers/app/privateRoute.js